import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { useProtectedAreasMethodology } from '@/hooks/useProtectedAreasMethodology';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const METHODOLOGY_PROTECTED_AREAS = {
  IBAT: undefined, // to be added when available
  OSM: 'https://www.thelandbankinggroup.com/science/indicators/protected-areas-in-vicinity-12f1d',
};

export const ProtectedAreasExplainer = () => {
  const { t } = useTranslation();

  const { hasIbat, hasOsm } = useProtectedAreasMethodology();

  if (!hasIbat && !hasOsm) {
    return null;
  }

  const methodologyLink = hasIbat ? METHODOLOGY_PROTECTED_AREAS.IBAT : METHODOLOGY_PROTECTED_AREAS.OSM;

  return (
    <Explainer>
      <ExplainerTrigger data-testid='protected-areas-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.details.protectedAreas.explainers.howDoMeasureThis.headline')}
        </ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              body={
                hasIbat
                  ? t('shared.ncaDetail.details.protectedAreas.explainers.howDoMeasureThis.protectedAreasBodyIBAT')
                  : t('shared.ncaDetail.details.protectedAreas.explainers.howDoMeasureThis.protectedAreasBodyOSM')
              }
            />
          </ExplainerBody>
          {methodologyLink && <MethodologyLink to={methodologyLink} />}
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
